import type { CounterpartyComboboxValue } from "@components/transactions/TransactionSplitV2/CounterpartyCombobox";
import type { CounterpartyOptionText } from "@components/transactions/TransactionSplitV2/CounterpartyComboboxPopup";

/**
 * Row text for the invoice recipient dropdowns: the contact's name, with its
 * email as the hint right after it. A contact without a name shows its email
 * as the label instead.
 */
export function toContactOption(
    contact: CounterpartyComboboxValue,
): CounterpartyOptionText {
    if (contact.name) {
        return { label: contact.name, labelHint: contact.email ?? undefined };
    }
    return { label: contact.email ?? "Unnamed contact" };
}
